export default "__VITE_ASSET__CJUE6qeP__"